import { Injectable } from '@angular/core';
import { BaseService } from '../Base/BaseService';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../Interceptor/auth.service';
import { SessionStorageService } from '../sessionStorageService/session-storage.service';
import { formSections, formSectionsFilter } from 'src/app/Model/formSections.model';

@Injectable({
  providedIn: 'root'
})
export class FormSectionsService extends BaseService{

  constructor(public http: HttpClient, public lsService: SessionStorageService, authService: AuthService) {
    super(http, lsService, authService);
    this.Component = "FormSectionsService";
  }

  public async get(idFlow: number) {
    let request: formSections[];
    await this.PostData(idFlow, "FormSections", "Get").then((res) => {
      if (res.head.status != 'False') {
        request = JSON.parse(res.body.response);
      }
    });
    return request;
  }

  public async getByProfile(filter: formSectionsFilter) {
    let request: formSections[];
    await this.PostData(filter, "FormSections", "GetByProfile").then((res) => {
      if (res.head.status != 'False') {
        request = JSON.parse(res.body.response);
      }
    });
    return request;
  }
}
